import { useSyncExternalStore } from 'react';

import { kioskEngine, type KioskState } from './syncEngine';

/** Reactive view of the shared kiosk engine state (online/queue/clocked-in/echo). */
export function useKioskState(): KioskState {
  return useSyncExternalStore(kioskEngine.subscribe, kioskEngine.getState, kioskEngine.getState);
}
